import { useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/contexts/AuthContext";

export default function WebsiteRenewalAdmin({ locked, run }) {
  const { user } = useAuth();
  const [state, setState] = useState("awaiting_review");
  const [data, setData] = useState(null);
  const [references, setReferences] = useState({});
  const [notice, setNotice] = useState("");
  const labels = {
    awaiting_review: "Awaiting review", approved: "Approved", processing: "Processing",
    renewed: "Renewed", review_required: "Review required", failed: "Not confirmed",
  };
  const load = async () => {
    const response = await axios.get(API + "/website-builder/publications/hosting/renewal-admin", {
      params: { state },
    });
    setData(response.data);
  };
  const approve = (item) => {
    const reference = (references[item.id] || "").trim();
    if (locked || !data?.approval_enabled || reference.length < 8) return;
    if (!window.confirm("Approve registrar-balance funding for " + item.years + " year(s) of renewal for " +
      item.domain + "? Confirm you reviewed the current registrar price and balance. This approval does not execute the renewal.")) return;
    return run("approve-renewal", async () => {
      await axios.post(API + "/website-builder/publications/hosting/renewal-admin/" + item.id + "/approve", {
        confirm_registrar_balance_debit: true, price_review_reference: reference,
      });
      setNotice("Approval recorded. Registrar renewal has not been executed.");
      await load();
    });
  };
  const execute = (item) => {
    if (locked || !data?.execution_enabled) return;
    if (!window.confirm("Execute the approved renewal for " + item.domain +
      " now? Namecheap may debit the registrar balance. Price review: " +
      (item.price_review_reference || "not recorded") + ".")) return;
    return run("execute-renewal", async () => {
      const response = await axios.post(API + "/website-builder/publications/hosting/renewal-admin/" + item.id + "/execute", {
        confirm_execution: true,
      });
      setNotice("Renewal processing result: " + (labels[response.data.state] || "Review the request status"));
      await load();
    });
  };

  if (user?.is_founder !== true) return null;
  return <section className="space-y-3 rounded border p-3" aria-label="Founder domain renewal approvals">
    <h3 className="text-sm font-semibold">Founder · domain renewals</h3>
    <p className="text-xs text-slate-500">Review current registrar pricing and balance before approval. Approval and execution are separate. Premium/expired domains and uncertain outcomes require manual review. Customer billing is separate.</p>
    <label className="block text-sm">Request status
      <select value={state} disabled={locked} className="ml-2 rounded border p-2"
        onChange={(event) => { setState(event.target.value); setData(null); setNotice(""); }}>
        {Object.entries(labels).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
      </select>
    </label>
    <button type="button" disabled={locked} onClick={() => run("renewal-admin-list", load)}
      className="rounded border px-3 py-2 text-sm disabled:opacity-50">Load renewal requests</button>
    {notice && <p role="status" className="text-sm">{notice}</p>}
    {data && <div className="space-y-2">
      <p className="text-xs text-slate-500">Oldest 50 requests in the selected status. Both approval and execution are disabled until separately configured.</p>
      {data.requests.length === 0 && <p className="text-xs text-slate-500">No requests in this status.</p>}
      {data.requests.map((item) => <div key={item.id} className="space-y-2 rounded border p-3 text-xs">
        <p className="font-medium">{item.domain} · {item.years} year(s) · Current expiry: {item.expected_expiry}</p>
        {(item.state === "awaiting_review" || item.state === "failed") && <>
          <label className="block">Current price review reference
            <input type="text" value={references[item.id] || ""} maxLength={200} disabled={locked}
              onChange={(event) => setReferences((current) => ({ ...current, [item.id]: event.target.value }))}
              className="mt-1 block w-full rounded border p-2" />
          </label>
          <button type="button" disabled={locked || !data.approval_enabled || (references[item.id] || "").trim().length < 8}
            onClick={() => approve(item)} className="rounded border px-3 py-2 disabled:opacity-50">Approve registrar-balance funding</button>
        </>}
        {item.state === "approved" && <>
          <p>Review reference: {item.price_review_reference}</p>
          <p>Approval expires: {item.approval_expires_at}</p>
          <button type="button" disabled={locked || !data.execution_enabled} onClick={() => execute(item)}
            className="rounded border px-3 py-2 disabled:opacity-50">Execute approved renewal</button>
        </>}
      </div>)}
    </div>}
  </section>;
}
